import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AppLanguage,
  LanguageService,
} from 'src/app/shared/services/language.service';
import {
  AppPageTexts,
  getAppTexts,
} from 'src/app/shared/i18n/app-text';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @ViewChild('modalPayment') paymentModal: TemplateRef<any>;
  closeResult: string;

  test: Date = new Date();
  currentLang: AppLanguage = 'es';
  texts: AppPageTexts<'footer'> = getAppTexts('footer', 'es');

  constructor(
    private modalService: NgbModal,
    private readonly languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.languageService.currentLang$.subscribe((language) => {
      this.currentLang = language;
      this.texts = getAppTexts('footer', language);
    });
  }

  onModal(): void {
    this.showPayment();
  }

  showPayment(): void {
    this.modalService
      .open(this.paymentModal, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  onNext(): void {
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
